import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  ElementRef,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '@environments/environment';
import { AuthDictionary } from '@app/core/constants';
import { AuthService, UtilitiesService } from '@app/core/services';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface Credentials {
  login: string;
  password: string;
}

@Component({
  selector: 'app-mobile-auth',
  templateUrl: './mobile-auth.component.html',
  styleUrls: ['./mobile-auth.component.scss'],
})
export class MobileAuthComponent implements OnInit, OnDestroy {
  @Output() credentials = new EventEmitter<Credentials>();
  @Output() displayModal = new EventEmitter();
  @Input() isOnlineMode$!: boolean | null;
  @ViewChild('loginInput') public readonly loginInput!: ElementRef<HTMLInputElement>;
  @ViewChild('passwordInput') public readonly passwordInput!: ElementRef<HTMLInputElement>;
  private readonly messageVissibilitySatus = new BehaviorSubject<boolean>(false);
  readonly messageVissibilitySatus$ = this.messageVissibilitySatus.asObservable();
  readonly loginStatus$ = this.AuthService.isUserLoggingIn$;
  readonly loginText = AuthDictionary.LoginTxt;
  readonly rememberPassTxt = AuthDictionary.RememberPassTxt;
  readonly doNotHaveAnAccountText = AuthDictionary.DoNotHaveAnAccountTxt;
  readonly deleteAccountHelpTxt = AuthDictionary.DeleteAccountHelpTxt;
  readonly privacyPolicyHelpTxt = AuthDictionary.PrivacyPolicyHelpTxt;
  readonly loginOrPassDoesNotExistText = AuthDictionary.LoginOrPassDoNotExist;
  readonly requiredTxt = AuthDictionary.FieldRequiredText;
  readonly rememberPasswordPageUrl = environment.rememberPasswordPageUrl;
  readonly deleteAccountHelpPageUrl = environment.deleteAccountHelpPageUrl;
  readonly privacyPolicyPageUrl = environment.privacyPolicyPageUrl;
  readonly registryGwoUrl = environment.registryGwoUrl;
  show = false;
  loginForm!: FormGroup;
  isSubmitted = false;
  private readonly mobileBlockerSubscription = this.utilitiesService.mobileBlockerVisible$
    .pipe(filter((isMobileOrientationBlocker: boolean) => isMobileOrientationBlocker))
    .subscribe(() => {
      this.loginInput?.nativeElement.blur();
      this.passwordInput?.nativeElement.blur();
    });

  constructor(
    private formBuilder: FormBuilder,
    private AuthService: AuthService,
    private utilitiesService: UtilitiesService
  ) {}

  passwordShow(): void {
    this.show = !this.show;
  }

  toggleLoginMessage(): void {
    this.messageVissibilitySatus.next(true);
    setTimeout(() => {
      this.messageVissibilitySatus.next(false);
    }, 250);
  }

  displayOfflineModal(): void {
    this.displayModal.emit();
  }

  startLogIn(): void {
    const login = this.loginForm.get('email')?.value;
    const password = this.loginForm.get('password')?.value;
    this.credentials.emit({ login, password });
  }

  onSubmit(): void {
    this.toggleLoginMessage();
    this.isSubmitted = true;
    const trimmedEmail = this.loginForm.controls['email'].value.replace(/ /g, '');
    this.loginForm.controls['email'].setValue(trimmedEmail);
    if (this.loginForm.valid) {
      this.startLogIn();
    }
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: new FormControl('', { validators: [Validators.required] }),
      password: new FormControl('', { validators: [Validators.required] }),
    });
  }

  onFocus(): void {
    this.isSubmitted = false;
  }

  public ngOnDestroy(): void {
    this.mobileBlockerSubscription.unsubscribe();
  }
}
